import { useCallback } from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpc, trpcUtils } from "@editor/utils/trpc";

import { useWebContainer } from "@/features/web-container/context";
import { useNavigate } from "react-router-dom";

export const useResetFiles = () => {
  const projectId = useCurrentProjectId();
  const navigate = useNavigate();
  const { restart } = useWebContainer();
  const { mutate: resetFilesMutate, isPending: isLoadingFilesReset } =
    trpc.nextJSProject.resetFiles.useMutation({
      onSuccess: async () => {
        await trpcUtils.webContainer.getFileTree.invalidate({
          projectId,
        });
        await trpcUtils.funnel.list.invalidate({
          projectId,
        });
        restart();
        navigate(`/shops/${projectId}/funnels`);
      },
    });
  const resetFiles = useCallback(() => {
    if (!projectId) {
      return;
    }
    resetFilesMutate({
      projectId,
    });
  }, [resetFilesMutate, projectId]);
  return { resetFiles, isLoadingFilesReset };
};
